import { NAME } from "./constants";

export const GET_LOCK_ACTIVITY = NAME + "GET_LOCK_ACTIVITY";
export const GET_USER_LOCKS = NAME + "GET_USER_LOCKS";
export const GET_GUEST_LOCK_ACTIVITY = NAME + "GET_GUEST_LOCK_ACTIVITY";
